module.exports = __webpack_public_path__ + "03a956590c4c8685003f8739eb6cf1fb.png";